import apiFetch from '../apiFetch'

export default function (token, detailId) {
  const queryParamsArray = [
    `detailId=${detailId}`
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `CampaignDetails/Recover${queryParams}`, method: 'POST', body: null, token: token })
}
